<template>
  <div class="container-fluid py-3">
    <h3 class="font-weight-bold text-primary mb-3">Front desk</h3>
    <attendance-desk />
  </div>
</template>

<script>
import AttendanceDesk from './AttendanceDesk.vue'

/** /subscription-checkin page. All logic lives in AttendanceDesk. */
export default {
  name: 'SubscriptionAttendantDashboard',

  components: { AttendanceDesk },
}
</script>
